import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translation from "../../../../shared/Translation";
import { getXssFilter } from '@showclix-shared-util/xssFilter';

class WaiverQuestion extends Component {
    constructor(props) {
        super(props);
        this.xssFilter = getXssFilter();
    }

    render() {

        if (this.props.isKioskMode) {
            return (
                <div className="kiosk__waiver-question">
                    <div className="input" onClick={this.props.transitionToWaiver}>
                        <div className={"input__radio delivery__option" + (this.props.waiverChecked ? ' input__radio--selected' : '')}>
                            <div className="input__radio-wrap">
                                <div className="input__radio__input">
                                    <input name="delivery" type="radio"
                                        id={"waiver_id_"+this.props.id}
                                        checked={this.props.waiverChecked}
                                        readOnly
                                    />
                                    <i className={`input__radio__mask ${this.props.waiverChecked ? "icon-radio_on" : "icon-radio_off"}`} aria-hidden="true"></i>
                                </div>
                                <label className="input__radio__label" htmlFor={"waiver_id_"+this.props.id}>
                                    <div className="input__radio__label-text"><Translation>{'checkout__review_and_sign_waiver'}</Translation></div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return(
            <div className="input">
                <div className="question__waiver__text" dangerouslySetInnerHTML={{__html: this.props.waiver}} />
                <div className={`input__checkbox waiver__checkbox ${this.props.waiverChecked ? 'input__checkbox--selected' : ''}`}>
                    <div className="input__checkbox__input">
                        <input type="checkbox" id={"waiver_id_"+this.props.id}
                            name="waiver"
                            checked={this.props.waiverChecked}
                            onChange={this.onAnswerUpdate}
                        />
                    </div>
                    <label 
                        htmlFor={"waiver_id_"+this.props.id} 
                        className="input__checkbox__label"
                        dangerouslySetInnerHTML={{ __html: this.xssFilter.process(this.props.waiverLabel) }}
                    />
                </div>
           </div>
        )

    }

    onAnswerUpdate = (e) => {
        this.props.onAnswerUpdate(e.target.checked);
    }
}

WaiverQuestion.defaultProps = {
    waiverChecked: false
}

WaiverQuestion.propTypes = {
    waiverLabel: PropTypes.string.isRequired,
    waiver: PropTypes.string.isRequired,
    waiverChecked: PropTypes.bool,
    onAnswerUpdate: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    isKioskMode: PropTypes.bool,
    transitionToWaiver: PropTypes.func,
}

export default WaiverQuestion;
